import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export default function ReservationsFilters({ 
  filters, 
  setFilters, 
  channels, 
  statusOptions 
}) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex flex-wrap gap-4">
          <div className="flex-1 min-w-[200px]">
            <Input
              placeholder="Rechercher..."
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              className="w-full"
              data-testid="search-input"
            />
          </div>
          <Select 
            value={filters.source || 'all'} 
            onValueChange={(v) => setFilters({ ...filters, source: v === 'all' ? '' : v })}
          >
            <SelectTrigger className="w-[150px]" data-testid="source-filter">
              <SelectValue placeholder="Source" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Toutes</SelectItem>
              {channels.map(channel => (
                <SelectItem key={channel.code} value={channel.code}>
                  {channel.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Select 
            value={filters.status || 'active'} 
            onValueChange={(v) => setFilters({ ...filters, status: v })}
          >
            <SelectTrigger className="w-[180px]" data-testid="status-filter">
              <SelectValue placeholder="Statut" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="active">À venir / En cours</SelectItem>
              <SelectItem value="past">Terminées</SelectItem>
              <SelectItem value="all">Toutes</SelectItem>
              {statusOptions.map(status => (
                <SelectItem key={status.code} value={status.code}>
                  <div className="flex items-center gap-2">
                    <div 
                      className="w-2 h-2 rounded-full" 
                      style={{ backgroundColor: status.color }}
                    />
                    {status.label}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
